var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "filtros-container" }, [
      _c(
        "div",
        {
          staticClass: "subfiltro-container",
          class:
            _vm.selectorDeFechasActivo == "yearAndMonth"
              ? "filtro-highlighted"
              : "",
          on: {
            click: function ($event) {
              _vm.selectorDeFechasActivo = "yearAndMonth"
            },
          },
        },
        [
          _c("YearAndMonthInput", {
            attrs: {
              yearLabel: "Año",
              monthLabel: "Mes",
              years: _vm.yearOptions,
              months: _vm.monthOptions,
            },
            model: {
              value: _vm.yearAndMonth,
              callback: function ($$v) {
                _vm.yearAndMonth = $$v
              },
              expression: "yearAndMonth",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "subfiltro-container",
          class:
            _vm.selectorDeFechasActivo == "rangeDate"
              ? "filtro-highlighted"
              : "",
          on: {
            click: function ($event) {
              _vm.selectorDeFechasActivo = "rangeDate"
            },
          },
        },
        [
          _c("span", { staticClass: "filtro-title" }, [
            _vm._v("Seleccionar fechas"),
          ]),
          _vm._v(" "),
          _c("date-picker", {
            staticClass: "w-auto",
            attrs: {
              lang: "es",
              "default-value": _vm.rangeDate,
              range: "",
              type: "date",
              format: "YYYY-MM-DD",
              valueType: "format",
              placeholder: "Seleccione un rango",
              "disabled-date": _vm.disabledRange,
              clearable: false,
            },
            model: {
              value: _vm.rangeDate,
              callback: function ($$v) {
                _vm.rangeDate = $$v
              },
              expression: "rangeDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "subfiltro-container" },
        [
          _c("span", { staticClass: "filtro-title" }, [_vm._v("Canal")]),
          _vm._v(" "),
          _c("b-form-select", {
            attrs: { options: _vm.canalesOptions },
            model: {
              value: _vm.idCanal,
              callback: function ($$v) {
                _vm.idCanal = $$v
              },
              expression: "idCanal",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-container subfiltro-container" },
        [
          _c(
            "b-btn",
            {
              attrs: {
                variant: "primary",
                disabled: !_vm.estaHabilitaoBotonBusqueda,
              },
              on: { click: _vm.handleBuscarClick },
            },
            [
              _c("i", { staticClass: "fas fa-search" }),
              _vm._v("\n        Buscar\n      "),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "flex-end",
            "margin-bottom": "10px",
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary btn-circle",
              attrs: {
                disabled: !_vm.estaHabilitaoBotonBusqueda,
                type: "button",
              },
              on: { click: _vm.handleDownloadClick },
            },
            [_c("i", { staticClass: "fas fa-download" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-link",
              staticStyle: { color: "#00184D" },
              attrs: { disabled: !_vm.estaHabilitaoBotonBusqueda },
              on: { click: _vm.handleDownloadClick },
            },
            [
              _vm.loading
                ? _c("b-spinner", { attrs: { small: "", label: "Loading..." } })
                : _vm._e(),
              _vm._v(" Descargar\n      "),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.error
        ? _c("div", [
            _vm._v(
              "\n      Error al realizar la descarga, intente nuevamente.\n    "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h4", { staticClass: "title" }, [_vm._v("Filtros")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }